import { render, staticRenderFns } from "./gcscc.vue?vue&type=template&id=053c7155&scoped=true&"
import script from "./gcscc.vue?vue&type=script&lang=js&"
export * from "./gcscc.vue?vue&type=script&lang=js&"
import style0 from "./gcscc.vue?vue&type=style&index=0&id=053c7155&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053c7155",
  null
  
)

export default component.exports